import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import Login from '../components/Login';
import { useAuth } from '../contexts/AuthContext';
import Profile from '../pages/Akun/Profile';
import ProfileDetail from '../pages/Akun/ProfileDetail';
import ChatHistories from '../pages/ChatHistory/chat/ChatHistories';
import ConcernPolicyForm from '../pages/Concern/ConcernPolicyForm';
import NewSyaratKetentuan from '../pages/Concern/NewSyaratKetentuan';
import HealthRecord from '../pages/HealthRecord/HealthRecord';
import Home from '../pages/Home';
import NotFoundPage from '../pages/NotFoundPage';
import AddressPage from '../pages/Prescription/AddressPage';
import CheckOutPage from '../pages/Prescription/CheckOutPage';
import FullscreenLoading from '../pages/Prescription/Components/FullScreenLoader';
import EprescriptionDetail from '../pages/Prescription/EprescriptionDetail';
import EprescriptionList from '../pages/Prescription/EprescriptionList';
import EprescriptionOrder from '../pages/Prescription/EprescriptionOrder';
import ReferenceDetail from '../pages/Reference/ReferenceDetail';
import BookingConfirm from '../pages/Reference/BookingConfirm';
import DoctorList from '../pages/Reference/DoctorList';
import BookingSchedule from '../pages/Reference/BookingSchedule';
import ReferenceList from '../pages/Reference/ReferenceList';
import SimpleVideoCallForm from '../pages/VideoCall/SimpleVideoCallForm';
import VideoCall from '../pages/VideoCall/VideoCall';
import VideoCallUI from '../pages/VideoCall/VideoCallUI';
import CheckoutTeleconsultation from '../pages/tanya-dokter/DetailTransaction/CheckoutTeleconsultation';
import PaymentMethodPage from '../pages/tanya-dokter/DetailTransaction/PaymentMethodPage';
import PaymentSuccess from '../pages/tanya-dokter/DetailTransaction/PaymentSuccess';
import VoucherPage from '../pages/tanya-dokter/DetailTransaction/Voucher';
import Chat from '../pages/tanya-dokter/chat/Chat';
import ConnectingDoctor from '../pages/tanya-dokter/disclaimer/ConnectingDoctor';
import Disclaimer from '../pages/tanya-dokter/disclaimer/Disclaimer';
import ListDoctor from '../pages/tanya-dokter/list/ListDoctor';
import ScheduleConsultation from '../pages/tanya-dokter/list/ScheduleConsultation';
import BenefitList from '../pages/Benefit/BenefitList';
import { useAuthStore } from '../stores/authStores';
import { PrivateRoute } from '../components/PrivateRoute';

const Router: React.FC = () => {
  const token = useAuthStore((s) => s.token)

  return (
    <Routes>
      <Route
        path="/"
        element={
          token ? <Navigate to="/home" replace /> : <Navigate to="/login" replace />
        }
      />
      <Route
        path="/login"
        element={
          token ? <Navigate to="/home" replace /> : <Login />
        }
      />
      <Route
        path="/home"
        element={
          <PrivateRoute>
            <Home />
          </PrivateRoute>
        }
      />
      <Route
        path="/chat/:conversationID/:token"
        element={
          <PrivateRoute>
            <Chat />
          </PrivateRoute>
        }
      />
      <Route
        path="/disclaimer/:practitionerRoleId"
        element={
          <PrivateRoute>
            <Disclaimer />
          </PrivateRoute>
        }
      />
      <Route
        path="/checkout-teleconsultation/:practitionerRoleId"
        element={
          <PrivateRoute>
            <CheckoutTeleconsultation />
          </PrivateRoute>
        }
      />
      <Route
        path="/payment-success"
        element={
          <PrivateRoute>
            <PaymentSuccess />
          </PrivateRoute>
        }
      />
      <Route
        path="/payment-method/:practitionerRoleId"
        element={
          <PrivateRoute>
            <PaymentMethodPage />
          </PrivateRoute>
        }
      />
      <Route
        path="/voucher/:practitionerRoleId"
        element={
          <PrivateRoute>
            <VoucherPage />
          </PrivateRoute>
        }
      />
      <Route
        path="/connect-doctor/:teleconsultationId/:token"
        element={
          <PrivateRoute>
            <ConnectingDoctor />
          </PrivateRoute>
        }
      />
      <Route
        path="/benefit"
         element={
          <PrivateRoute>
            <BenefitList />
          </PrivateRoute>
        }
      />
      <Route
        path="/profile-detail"
         element={
          <PrivateRoute>
            <ProfileDetail />
          </PrivateRoute>
        }
      />
      <Route
        path="/e-prescription"
         element={
          <PrivateRoute>
            <EprescriptionList />
          </PrivateRoute>
        }
      />
      <Route
        path="/e-prescription/:prescriptionId"
         element={
          <PrivateRoute>
            <EprescriptionDetail />
          </PrivateRoute>
        }
      />
      <Route
        path="/e-prescription/:prescriptionId/order"
        element={
          <PrivateRoute>
            <EprescriptionOrder />
          </PrivateRoute>
        }
      />
      <Route
        path="/e-prescription/checkout/:prescriptionId/:token"
        element={
          <PrivateRoute>
            <CheckOutPage />
          </PrivateRoute>
        } 
      />
      <Route
        path="/e-prescription/address-page/:prescriptionId/:token"
        element={
          <PrivateRoute>
            <AddressPage />
          </PrivateRoute>
        }
      />
      <Route
        path="/reference"
         element={
          <PrivateRoute>
            <ReferenceList />
          </PrivateRoute>
        }
      />
      <Route
        path="/reference/:referenceId"
         element={
          <PrivateRoute>
            <ReferenceDetail />
          </PrivateRoute>
        }
      />
     <Route
      path="/reference/:referenceId/booking/doctors"
      element={
          <PrivateRoute>
            <DoctorList />
          </PrivateRoute>
        }
    />
    <Route
      path="/reference/:referenceId/booking/schedule"
      element={
          <PrivateRoute>
            <BookingSchedule />
          </PrivateRoute>
        }
    />
    <Route
      path="/reference/:referenceId/booking/confirm"
      element={
          <PrivateRoute>
            <BookingConfirm />
          </PrivateRoute>
        }
    />
      <Route
        path="/akun"
        element={
          <PrivateRoute>
            <Profile />
          </PrivateRoute>
        }
      />

      <Route
        path="/concerns/:token"
        element={
          <PrivateRoute>
            <ConcernPolicyForm />
          </PrivateRoute>
        }
      />

      <Route
        path="/new-syarat-dan-ketentuan"
        element={
          <PrivateRoute>
            <NewSyaratKetentuan />
          </PrivateRoute>
        }
      />

      <Route
        path="/chat-history"
         element={
          <PrivateRoute>
            <ChatHistories />
          </PrivateRoute>
        }
      />

      <Route
        path="/health-record"
         element={
          <PrivateRoute>
            <HealthRecord />
          </PrivateRoute>
        }
      />

      <Route
        path="/list-doctor"
         element={
          <PrivateRoute>
            <ListDoctor />
          </PrivateRoute>
        }
      />

      <Route
        path="/schedule-consultation/:doctorId"
        element={
          <PrivateRoute>
            <ScheduleConsultation />
          </PrivateRoute>
        }
      />

      <Route
        path="/not-found"
          element={
          <PrivateRoute>
            <NotFoundPage />
          </PrivateRoute>
        }
      />
      <Route
        path="/video-call"
          element={
          <PrivateRoute>
            <VideoCall />
          </PrivateRoute>
        }
      />
      <Route
        path="/video-call-ui/:teleconsultationId/:token"
          element={
          <PrivateRoute>
            <VideoCallUI />
          </PrivateRoute>
        }
      />
       <Route
        path="/form-video-call"
          element={
          <PrivateRoute>
            <SimpleVideoCallForm />
          </PrivateRoute>
        }
      />


    </Routes>
  );
};

export default Router;
